import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Use_Of_Reference_Material_Table from "./use_of_reference_material_table/Use_Of_Reference_Material_Table";
import Use_Of_Reference_Material_Filter from "./use_of_reference_material_filter/Use_Of_Reference_Material_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";

const Use_Of_Reference_Material = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <Use_Of_Reference_Material_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Use_Of_Reference_Material_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Use_Of_Reference_Material;
